module.exports = __webpack_public_path__ + "img/card-motor.a91eb34d.jpg";